import { render } from "./AposRichTextWidgetEditor.vue?vue&type=template&id=17018857&scoped=true"
import script from "./AposRichTextWidgetEditor.vue?vue&type=script&lang=js"
export * from "./AposRichTextWidgetEditor.vue?vue&type=script&lang=js"

import "./AposRichTextWidgetEditor.vue?vue&type=style&index=0&id=17018857&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17018857"],['__file',"rich-text-widget/ui/apos/components/AposRichTextWidgetEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17018857"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17018857', __exports__)) {
    api.reload('17018857', __exports__)
  }
  
  module.hot.accept("./AposRichTextWidgetEditor.vue?vue&type=template&id=17018857&scoped=true", () => {
    api.rerender('17018857', render)
  })

}


export default __exports__